<div class="container p-3">
  <div class="row">
    <div class="col col-12 text-center">
      <h1>Verify email address</h1>
    </div>
  </div>
  <div class="row">
    <div class="col col-12">
      <p class="text-center mb-0">
        Thank you for registering. A confirmation email has been sent to the
        email address you supplied. Follow the instructions in the email to
        verify your account
      </p>
    </div>
  </div>
  <form [formGroup]="validationForm" class="w-lg-50 m-auto pt-3">
    <div class="row">
      <div class="col col-12">
        <label for="token" class="">Verify code:</label>
        <input
          type="text"
          id="token"
          class="form-control"
          formControlName="token" />
        <div *ngIf="confirmationErrorMessage" class="alert alert-danger">
          <p class="mb-0">{{ confirmationErrorMessage }}</p>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col col-12 text-center">
        <app-button
          [observeApi]="true"
          [text]="'Confirm'"
          [Click]="submitForm"
          [color]="'orange'"
          [size]="'normal'"
          [style]="'rounded'"></app-button>
      </div>
    </div>
  </form>
</div>
